<script setup lang="ts">
import type {ArticleAsset} from '@/types';
import {HomeFeature, HomeFeatureTile, HomeFeatureContent, HomeFeatureContentLogo, HomeFeatureContentBody} from '@/lib/ui/home-feature';

const {translate} = useTranslation();
// const {fetchAssetBySlug} = useCmsStore();
const data = ref();
// const resp = await fetchAssetBySlug<ArticleAsset>('one-lavs-experience');
// if (!resp.error) {
//   data.value = resp;
// }

if (import.meta.client) {
  const {data: lazyResp, error} = await useLazyFetch<ArticleAsset>(`/api/asset-by-slug?slug=one-lavs-experience&status=${window ? (window.location !== window.parent.location ? 'draft' : 'published') : 'published'}`, {server: false});

  if (lazyResp.value && !error) {
    data.value = lazyResp.value as ArticleAsset;
  }

  watch(lazyResp, (article: ArticleAsset) => {
    data.value = article;
  });
}
</script>

<template>
  <HomeFeature class="bg-[var(--bathrooms-color)]">
    <template v-if="data">
      <HomeFeatureTile>
        <img :src="data.fields.feature_image.public_url" alt="Bathrooms Icon" class="m-auto" />

        <img v-gsap.whenVisible.once.reversible.from="{opacity: 0, y: '20%'}" :src="data.fields.feature_icon.public_url" alt="Bathrooms Icon" class="mobile-only" />
      </HomeFeatureTile>

      <HomeFeatureContent class="bathrooms-feature-content__overrides">
        <div class="h-full border-[3rem] border-[var(--bathrooms-color-lighter)] bg-[var(--bathrooms-color-darker)]">
          <HomeFeatureContentLogo :reverse="true">
            <img :src="data.fields.feature_icon.public_url" alt="One Lavs Logo" class="m-auto" />
          </HomeFeatureContentLogo>

          <HomeFeatureContentBody>
            <div class="flex flex-col gap-[3rem] text-white" v-html="translate(data.fields.content)" />

            <ul class="flex gap-[2rem]">
              <li>
                <TheButton tag="NuxtLink" class="!bg-[var(--bathrooms-color)] !text-white !border-none hover:!bg-white hover:!text-black !py-4" to="/bathrooms">Buy Tickets</TheButton>
              </li>
              <li>
                <TheButton tag="NuxtLink" class="!bg-[var(--bathrooms-color)] !text-white !border-none hover:!bg-white hover:!text-black !py-4" to="/bathrooms">Learn More</TheButton>
              </li>
            </ul>
          </HomeFeatureContentBody>
        </div>
      </HomeFeatureContent>
    </template>
  </HomeFeature>
</template>

<style lang="scss">
@use '@/assets/scss/queries';
.bathrooms-feature-content__overrides {
  padding: 8rem;

  @include queries.for-size(phone) {
    padding: 1rem;

    .home-feature__content-inner {
      max-width: 100% !important;
    }
  }

  .home-feature__content-inner {
    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 4rem;
      padding: 8rem;
      aspect-ratio: 1 / 1;
      @include queries.for-size(phone) {
        border-width: 0;
      }
    }
  }
}
</style>
